"use client";

import { useMemo, useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type GalleryImage = {
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  category: "cuts" | "color" | "styling" | "details";
  caption: string;
  aspect: "tall" | "wide" | "square";
};
const galleryImages: GalleryImage[] = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_precision_cut.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_precision_cut.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_precision_cut.png-wvc-sizes",
  alt: "Precision bob haircut",
  category: "cuts",
  caption: "PRECISION / BOB / FALL 2024",
  aspect: "tall"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_balayage_flow.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_balayage_flow.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_balayage_flow.png-wvc-sizes",
  alt: "Soft balayage highlights",
  category: "color",
  caption: "BALAYAGE / SUN-KISSED / OCT 2024",
  aspect: "wide"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_styling_session.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_styling_session.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_styling_session.png-wvc-sizes",
  alt: "Behind the chair styling",
  category: "styling",
  caption: "STUDIO / SESSION / AUG 2024",
  aspect: "square"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_shears_detail.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_shears_detail.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_shears_detail.png-wvc-sizes",
  alt: "Professional shears on station",
  category: "details",
  caption: "TOOLS / PRECISION / DETAIL",
  aspect: "square"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_vibrant_color.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_vibrant_color.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_vibrant_color.png-wvc-sizes",
  alt: "Vibrant copper transformation",
  category: "color",
  caption: "COLOR / COPPER / OCT 2024",
  aspect: "wide"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_layered_cut.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_layered_cut.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_layered_cut.png-wvc-sizes",
  alt: "Long layered haircut",
  category: "cuts",
  caption: "CUT / LAYERS / OCT 2024",
  aspect: "tall"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_treatment_process.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_treatment_process.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_treatment_process.png-wvc-sizes",
  alt: "Deep conditioning treatment",
  category: "details",
  caption: "CARE / TREATMENT / SEP 2024",
  aspect: "tall"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_updo_style.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_updo_style.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_updo_style.png-wvc-sizes",
  alt: "Elegant bridal updo",
  category: "styling",
  caption: "STYLE / UPDO / DETAIL",
  aspect: "square"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_modern_shag.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_modern_shag.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_modern_shag.png-wvc-sizes",
  alt: "Modern textured shag",
  category: "cuts",
  caption: "CUT / SHAG / JUL 2024",
  aspect: "wide"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_root_melt.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_root_melt.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_root_melt.png-wvc-sizes",
  alt: "Seamless root melt",
  category: "color",
  caption: "COLOR / ROOT MELT / OCT 2024",
  aspect: "square"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_blowout_finish.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_blowout_finish.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_blowout_finish.png-wvc-sizes",
  alt: "Glossy blowout finish",
  category: "styling",
  caption: "STYLE / BLOWOUT / SEP 2024",
  aspect: "wide"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_texture_detail.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_texture_detail.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701490/img/salon_texture_detail.png-wvc-sizes",
  alt: "Hair texture close up",
  category: "details",
  caption: "TEXTURE / DETAIL",
  aspect: "tall"
}];
const filters = [{
  value: "all",
  label: "ALL"
}, {
  value: "cuts",
  label: "CUTS"
}, {
  value: "color",
  label: "COLOR"
}, {
  value: "styling",
  label: "STYLING"
}, {
  value: "details",
  label: "DETAILS"
}];
const INITIAL_LOAD = 18;
export default function ColorCutGallery() {
  const [activeFilter, setActiveFilter] = useState<string>("all");
  const [visibleCount, setVisibleCount] = useState<number>(INITIAL_LOAD);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const filteredImages = useMemo(() => {
    if (activeFilter === "all") return galleryImages;
    return galleryImages.filter(img => img.category === activeFilter);
  }, [activeFilter]);
  const displayedImages = filteredImages.slice(0, visibleCount);
  const hasMore = visibleCount < filteredImages.length;
  const handleFilterChange = (value: string) => {
    if (!value) return;
    setActiveFilter(value);
    setVisibleCount(INITIAL_LOAD);
  };
  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const goPrev = () => {
    if (lightboxIndex === null) return;
    setLightboxIndex((lightboxIndex - 1 + displayedImages.length) % displayedImages.length);
  };
  const goNext = () => {
    if (lightboxIndex === null) return;
    setLightboxIndex((lightboxIndex + 1) % displayedImages.length);
  };
  const currentImage = lightboxIndex !== null ? displayedImages[lightboxIndex] : null;
  return <section data-section-id="98" id="color-cut-gallery" className="bg-background text-foreground py-20 md:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {}
        <div ref={headRef} className={`mx-auto max-w-4xl text-center transition-all duration-1000 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs tracking-[0.3em] uppercase mb-6 text-primary">THE ARTISTRY</p>
          <h2 className="font-default font-light text-5xl md:text-7xl lg:text-8xl text-foreground leading-[1.05]">
            Velvet{" "}
            <span className="italic text-primary">
              Shears.
            </span>
          </h2>
          <p className="mt-8 font-default text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            A curated collection of precision cuts, vibrant color transformations, and the artistry behind every chair.
          </p>
        </div>

        {}
        <div className="mt-14 md:mt-16 flex justify-center">
          <ToggleGroup type="single" value={activeFilter} onValueChange={handleFilterChange} className="flex flex-wrap justify-center gap-2 md:gap-3 rounded-md bg-transparent">
            {filters.map((f, i) => <ToggleGroupItem key={f.value} value={f.value} data-index={i} className="font-default text-[10px] md:text-xs tracking-[0.25em] uppercase px-4 md:px-5 py-2.5 md:py-3 rounded-md border bg-transparent text-foreground transition-all duration-300 hover:bg-primary/10 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:border-primary first:rounded-l-md last:rounded-r-md border-primary">
                {f.label}
              </ToggleGroupItem>)}
          </ToggleGroup>
        </div>

        {}
        <div className="mt-12 md:mt-16 columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5 [column-fill:_balance]">
          {displayedImages.map((image, i) => <Button key={`${image.src}-${activeFilter}`} data-index={i} onClick={() => openLightbox(i)} variant="ghost" className={`group relative mb-4 md:mb-5 block w-full break-inside-avoid overflow-hidden rounded-md border bg-muted p-0 h-auto cursor-pointer transition-opacity duration-500 animate-in fade-in ${image.aspect === "tall" ? "aspect-[3/4]" : image.aspect === "wide" ? "aspect-[4/3]" : "aspect-square"} border-border`}>
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
              {}
              <div className="pointer-events-none absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-foreground/80 via-foreground/40 to-transparent px-5 py-4 transition-transform duration-500 ease-out group-hover:translate-y-0">
                <p className="font-default text-[10px] tracking-[0.25em] uppercase text-background">
                  {image.caption}
                </p>
              </div>
            </Button>)}
        </div>

        {}
        {hasMore && <div className="mt-14 md:mt-16 flex justify-center">
            <Button variant="ghost" onClick={() => setVisibleCount(c => c + 9)} className="group relative font-default text-xs tracking-[0.3em] uppercase px-2 py-6 bg-transparent text-foreground hover:bg-transparent">
              <span className="relative pb-1.5">
                Load More
                <span className="absolute bottom-0 left-0 h-px w-full transition-all duration-500 bg-primary" />
              </span>
            </Button>
          </div>}

        {}
        {displayedImages.length === 0 && <div className="mt-20 text-center">
            <p className="font-default italic text-2xl text-muted-foreground">
              No images in this collection yet.
            </p>
          </div>}
      </div>

      {}
      <Dialog open={lightboxIndex !== null} onOpenChange={open => !open && closeLightbox()}>
        <DialogContent showCloseButton={false} className="max-w-[100vw] sm:max-w-[100vw] w-screen h-screen p-0 rounded-md border-0 bg-background flex flex-col">
          {currentImage && <>
              {}
              <div className="flex items-center justify-between px-6 md:px-10 pt-6 md:pt-8">
                <p className="font-default text-[10px] md:text-xs tracking-[0.3em] uppercase text-primary">
                  {lightboxIndex !== null ? String(lightboxIndex + 1).padStart(2, "0") : "00"}
                  <span className="mx-2 opacity-50">/</span>
                  {String(displayedImages.length).padStart(2, "0")}
                </p>
                <Button variant="ghost" size="icon" onClick={closeLightbox} className="rounded-md text-foreground hover:bg-accent" aria-label="Close">
                  <X className="size-5" />
                </Button>
              </div>

              {}
              <div className="flex flex-1 items-center justify-center px-4 md:px-16 lg:px-24 py-6 md:py-10 relative">
                <Button variant="ghost" size="icon" onClick={goPrev} className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 rounded-md text-foreground hover:bg-accent z-10" aria-label="Previous image">
                  <ChevronLeft className="size-6 md:size-7" />
                </Button>

                <div className="flex h-full max-h-[70vh] w-full items-center justify-center">
                  <img src={currentImage.src} data-wvc-srcset={currentImage.srcset} data-wvc-sizes={currentImage.sizes} alt={currentImage.alt} className="max-h-full max-w-full object-contain rounded-md" />
                </div>

                <Button variant="ghost" size="icon" onClick={goNext} className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 rounded-md text-foreground hover:bg-accent z-10" aria-label="Next image">
                  <ChevronRight className="size-6 md:size-7" />
                </Button>
              </div>

              {}
              <div className="px-6 md:px-10 pb-8 md:pb-12 text-center">
                <p className="font-default text-[10px] md:text-xs tracking-[0.3em] uppercase mb-3 text-primary">
                  {currentImage.caption}
                </p>
                <p className="font-default italic text-lg md:text-2xl text-foreground">
                  {currentImage.alt}
                </p>
              </div>
            </>}
        </DialogContent>
      </Dialog>
    </section>;
}